<div class="offer-details-dialog" *ngIf="offer.type === offerType.IFRAME || offer.type === offerType.LINK">
  <div
    class="image"
    [style.backgroundImage]="'url(' + offer.imageUrl + ')'"
    [style.backgroundColor]="offer.backgroundColor || ''"
  ></div>

  <mat-card-title>
    {{ offer.title }}
  </mat-card-title>

  <mat-card-content>
    <div class="content">
      {{ offer.content }}
    </div>

    <div class="extra">
      <app-iframe-offer
        *ngIf="offer.type === offerType.IFRAME"
        fxLayout="column"
        fxLayoutAlign="start stretch"
        [payload]="offer.payload"
      ></app-iframe-offer>
    </div>
  </mat-card-content>
</div>

<mat-dialog-actions align="start">
  <a
    mat-raised-button
    *ngIf="offer.type === offerType.LINK"
    color="accent"
    [href]="linkUrl"
    target="_blank"
    cdkFocusInitial
    (click)="linkClicked()"
    >{{ offer.payload.linkText }}</a
  >
  <button mat-button matDialogClose>Zamknij</button>
</mat-dialog-actions>
